// extracted by mini-css-extract-plugin
export default {"SelectedTeamHeader":"SelectedTeamHeader_SelectedTeamHeader__91kiJ"};